import React from 'react';

/**
 * 利用規約を表示するコンポーネント
 * 別タブで開かれることを想定し、戻るボタンは含みません。
 * ログイン状態にかかわらず表示可能です。
 */
const TermsOfService: React.FC<{}> = () => {
    return (
        <div className="p-4 sm:p-8 max-w-3xl mx-auto bg-white rounded-2xl shadow-xl">
            <div className="flex items-center mb-6">
                <h1 className="text-3xl font-bold text-gray-800 ml-4">利用規約</h1>
            </div>

            {/* 中高生向けの注意書きを上段に追加 */}
            <div className="p-4 mb-6 bg-red-50 border-l-4 border-red-400 rounded-lg shadow-md">
                <p className="font-bold text-lg text-red-800">
                    【QuizAを利用するみなさんへ】
                </p>
                <p className="mt-2 text-red-700">
                    QuizAは、みんなが安心して楽しく学べる場所です。
                </p>
                <p className="mt-1 text-red-700 font-semibold">
                    他者への<strong>誹謗中傷、差別、ハラスメント</strong>を目的としたクイズの作成は<strong>絶対にやめてください。</strong>
                </p>
                <p className="mt-1 text-red-700">
                    もしこのような規約違反があった場合、第5条に基づき、<strong>クイズの非公開・削除</strong>や<strong>アカウント停止</strong>といった対応を取ります。
                    みんなでルールを守り、気持ちよく利用できるコミュニティづくりにご協力をお願いします。
                </p>
            </div>

            <div className="prose max-w-none text-left text-gray-700 leading-relaxed">
                <p className="mb-4">
                    この利用規約（以下、「本規約」といいます。）は、QuizA（以下、「本サービス」といいます。）の利用に関する条件を定めるものです。本サービスをご利用になるすべてのユーザー（以下、「利用者」といいます。）は、本規約に同意したものとみなされます。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第1条（本規約への同意）</h2>
                <p className="mb-4">
                    利用者は、本サービスの利用を開始する前に本規約を熟読し、その内容に同意するものとします。本サービスを利用した時点で、利用者は本規約に同意したものとみなされます。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第2条（本サービスの性質）</h2>
                <p className="mb-4">
                    本サービスは、AIだけでどこまで開発ができるかの<strong>実証実験アプリケーション</strong>であり、そのほとんどを<strong>人工知能（AI）によって生成</strong>されています。そのため、予期せぬ動作や不完全な点が含まれる可能性があります。動作の安定性、正確性、安全性について保証するものではなく、ベータ版として提供されています。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第3条（サービスの内容）</h2>
                <p className="mb-4">
                    本サービスは、利用者がクイズを作成、学習、共有できるプラットフォームを提供します。作成されたコンテンツは他の利用者に公開される場合があります。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第4条（利用者の責任）</h2>
                <ul className="mb-4">
                    <li className="mb-2">利用者は、自己の責任において本サービスを利用するものとし、本サービスにおける一切の行為およびその結果について責任を負うものとします。</li>
                    <li className="mb-2">利用者は、本サービスを通じて作成、公開、共有するコンテンツが、第三者の知的財産権、プライバシー権、肖像権その他の権利を侵害しないことを保証するものとします。</li>
                    <li className="mb-2">法令または公序良俗に反する行為、本サービスの運営を妨害する行為は禁止します。</li>
                    <li className="mb-2">利用者間のトラブルについて、当社は一切関与いたしません。</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第5条（禁止行為およびアカウント削除）</h2>
                <p className="mb-4">
                    利用者は、以下の行為を行ってはなりません。QuizAは、利用者が以下の行為を行ったと判断した場合、事前に通知することなく、当該利用者のアカウントの停止または削除、および当該利用者が作成または公開したコンテンツ（クイズなど）の削除を行うことができるものとします。
                </p>
                <ul className="mb-4">
                    <li className="mb-2">公序良俗に反するコンテンツの作成または公開。</li>
                    <li className="mb-2">他者への誹謗中傷、差別、ハラスメントを目的としたコンテンツの作成または公開。</li>
                    <li className="mb-2">第三者の知的財産権、プライバシー権、肖像権その他の権利を侵害するコンテンツの作成または公開。</li>
                    <li className="mb-2">本サービスの運営に過度な負荷をかける行為、またはシステムに障害を与える行為。</li>
                    <li className="mb-2">不正アクセス、ハッキング、または本サービスのセキュリティを侵害する行為。</li>
                    <li className="mb-2">本サービスを不正な目的で利用する行為。</li>
                    <li className="mb-2">その他、QuizAが不適切と判断する行為。</li>
                </ul>
                <p className="mb-4">
                    上記措置により利用者に生じた損害について、QuizAは一切の責任を負いません。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第6条（知的財産権）</h2>
                <p className="mb-4">
                    本サービスに関する著作権、特許権、商標権、ノウハウその他の知的財産権は、QuizAまたは正当な権利者に帰属します。**利用者が本サービスを通じて作成したコンテンツ（クイズ等）の著作権は、作成者である利用者に帰属します。** ただし、QuizAは、本サービスの運営、プロモーション、改善に必要な範囲で、当該コンテンツを無償で利用（複製、公衆送信、翻案等を含む）できるものとします。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第7条（免責事項）</h2>
                <p className="mb-4">
                    本サービスの利用により発生した利用者の損害（データの消失、エラー、不具合等を含みますがこれらに限りません）について、QuizAは一切の責任を負わないものとします。ただし、QuizAに故意または重過失がある場合はこの限りではありません。本サービスはベータ版として提供されるため、利用者はこの点を理解し、自己の責任において利用するものとします。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第8条（本規約の変更）</h2>
                <p className="mb-4">
                    QuizAは、利用者の事前の承諾を得ることなく、本規約を改定できるものとします。改定内容は本サービス上または当社が適切と判断する方法により通知します。改定後の本規約は、本サービス上に表示された時点から効力を生じるものとします。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第9条（準拠法および管轄裁判所）</h2>
                <p className="mb-4">
                    本規約の解釈にあたっては日本法を準拠法とし、本サービスに関して紛争が生じた場合には、QuizAの本社所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第10条（未成年の利用について）</h2>
                <p className="mb-4">
                    本サービスは、小学生・中学生・高校生を含む未成年の利用を想定しています。16歳未満の利用者は、必ず保護者の同意を得たうえで本サービスをご利用ください。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第11条（保護者の責任）</h2>
                <p className="mb-4">
                    保護者は、未成年の利用者による本サービスの利用内容およびその結果について、適切に監督するものとします。QuizAは、未成年の利用が原因で生じた問題について、保護者と協力して解決に努めます。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第12条（サービスの一時停止・終了）</h2>
                <p className="mb-4">
                    QuizAは、以下の場合において、利用者への事前通知なく本サービスの全部または一部を一時的に中断、または恒久的に終了することができるものとします。
                </p>
                <ul className="mb-4">
                    <li className="mb-2">システムの保守点検、更新を行う場合</li>
                    <li className="mb-2">火災、停電、地震などの不可抗力によりサービスの提供が困難となった場合</li>
                    <li className="mb-2">運営上または技術上の理由で提供が困難になった場合</li>
                </ul>
                <p className="mb-4">
                    本サービスの終了により、利用者または第三者が被った損害について、QuizAは一切責任を負いません。
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">第13条（反社会的勢力の排除）</h2>
                <p className="mb-4">
                    利用者は、自己が暴力団、暴力団関係企業、総会屋、社会運動標榜ゴロその他これに準ずる反社会的勢力（以下「反社会的勢力」）に該当しないこと、また将来にわたっても該当しないことを表明し、保証するものとします。
                </p>
                <p className="mb-4">
                    QuizAは、利用者が反社会的勢力に該当すると判断した場合、何らの通知・催告を要せずに、当該利用者のサービス利用を停止し、または契約を解除することができるものとします。
                </p>

                <p className="mt-8 text-sm text-gray-500">最終更新日：2024年8月14日</p>
                <p className="mt-8 text-sm text-gray-500">
                    本サービスは、Google が提供する Firebase の無償枠（Firestore、Authentication、および Hosting）を活用して運営されています。Firebase の提供に感謝いたします。
                    <a href="https://firebase.google.com/?hl=ja" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline ml-1">
                        Firebaseについて詳しくはこちら
                    </a>
                </p>
            </div>
        </div>
    );
};

export default TermsOfService;
